'use strict';

(function (global) {

  // Селекторы для объектов Aspose.
  const asposeSelectors = {
    comments: 'div[id^=_cmnt]',
    commentAnchors: 'a[href^=#_cmnt]',
    commentArea: 'a[name*=_cmntref]',
  };

  // Имя css-класса для БЭМ-блока страницы документа.
  const documentPageBaseCssClass = 'word-document-page';

  // Селекторы для объектов комментариев.
  const wordDocumentSelector = {
    commentAnchors: '.msocomanchor',
    wrapper: {
      comments: `.${documentPageBaseCssClass}__comments`,
      mainContent: `.${documentPageBaseCssClass}__main-content`,
      page: `.${documentPageBaseCssClass}`,
    }
  };

  /**
   * @class WordDocumentPostprocessor
   * @classdesc Подготовка к предпросмотру документов MS Word.
   * @hideconstructor
   * @namespace window.Core.preview
   * @since 5.7.0
   */
  class WordDocumentPostprocessor extends global.BaseDocumentPostprocessor {

    // Костыль для IE10, иначе он не может наследовать родительский static метод с babel-preset-env 1.6.1
    /**
     * @see BaseDocumentPostprocessor.prepare
     */
    static prepare(jFrame, filePath, extension) {
      return super.prepare(jFrame, filePath, extension);
    }

    // Костыль для IE10, иначе он не может наследовать родительский static метод с babel-preset-env 1.6.1
    /**
     * @see BaseDocumentPostprocessor._addFilesToHead
     */
    static _addFilesToHead(jFrameContents, filePath) {
      return super._addFilesToHead(jFrameContents, filePath);
    }

    /**
     * @see BaseDocumentPostprocessor._prepareContents
     */
    static _prepareContents(jFrame, extension) {
      const jFrameContents = jFrame.contents();

      // Обернем страницы документа Word
      this._wrapWordPages(jFrameContents);

      // Обработать комментарии
      this._prepareComments(jFrameContents);

      // Навесим открытие гиперссылок в новом окне
      const anchors = jFrameContents.find('a');
      anchors
        .not(wordDocumentSelector.commentAnchors)
        .attr('target', '_blank');

      // HACK: Исправим ссылки в odt. Для ссылок задается тег span с inline-стилями.
      if (extension === 'ODT') {
        jFrameContents.find('a')
          .css('text-decoration', 'underline')
          .find('span')
          .css('color', '');
      }
    }

    /**
     * Обернуть страницы документа Word.
     *
     * @method _wrapWordPages
     * @param {object} jContents jQuery-объект страницы.
     * @private
     * @static
     */
    static _wrapWordPages(jContents) {
      // Получим css, сгенерированный Aspose
      const jStyle = jContents.find('style');
      const sectionSizes = this._getAsposeSectionSizes(jStyle);

      const jBody = jContents.find('body');
      jBody[0].classList = [];
      jBody.addClass('loc_preview-text-document');

      // Получить цвет фона страниц и убрать его для тела документа. В дальнейшем будет установлен для каждой страницы.
      // Цвет получается из свойства background-color, но Aspose устанавливает его в background. Поэтому нужно
      // удалить именно свойство background.
      let backgroundColor = jBody.css('background-color');
      if (['rgba(0, 0, 0, 0)', 'transparent'].includes(backgroundColor)) {
        // В случае, если в Word был выбран фон страницы - Нет, то будет возвращаться прозрачный фон.
        // Данный хак исправляет прозрачный фон на белый.
        backgroundColor = '#fff';
      }
      jBody.css('background', '');

      // Подготовим body для обработки на js
      // Получаем внутреннюю разметку для тела документа, оборачиваем в div и создаем новый jQuery элемент для
      // обработки, чтобы после каждого шага не происходило обновление стилей/разметки в браузере. После того, как
      // итоговый html будет сформирован, одним шагом обновим всю разметку в body.
      let jWrappedBody = $(`<div>${jBody.html()}</div>`);

      // Удалить page break
      jWrappedBody.find('br,hr').remove();

      // Обработать секции Aspose
      const asposeSection = jWrappedBody.find('[class*=Section]').toArray();
      const pages = asposeSection.map((domElement, index) => {
        const sourceHtml = domElement.outerHTML;
        const sizes = sectionSizes[ `section${index+1}` ];
        const mainContentCssStyles = `background: ${backgroundColor}; min-height: ${sizes[1]}; width: ${sizes[0]}`;

        // Каждый WordSection дополнительно обернем в PageSection и добавим область комментариев
        return `
        <div class="${documentPageBaseCssClass}" id="page-${index+1}" >
            <div class="${documentPageBaseCssClass}__main-content" style="${mainContentCssStyles}">
                ${sourceHtml}
            </div>
            <div class="${documentPageBaseCssClass}__comments"></div>
        </div>`;
      }).join('');

      // Получить разметку для комментариев
      const jComments = jWrappedBody
        .find('[id*=_cmnt]')
        .toArray();
      const commentsHtml = jComments
        .map((domElement) => domElement.outerHTML)
        .join('');

      jBody.html(`
        <div class="text-document-container">
            <div class="text-document-container__scaled-content">
                ${pages}
            </div>
        </div>
        ${commentsHtml}
      `);
    }

    /**
     * Получить размеры страниц документа.
     *
     * @method _getAsposeSectionSizes
     * @param {object} jStyle jQuery-объект css-стилей страницы (тег style).
     * @private
     * @return {object} sectionSizes Ассоциативный массив размеров секций (в веб-представлении - страниц) Aspose
     * @static
     */
    static _getAsposeSectionSizes(jStyle) {
      const cssText = jStyle[0].innerText;

      // Получим все css правила формата @page Section { size: ...}
      const asposeSizeRulesRegex = new RegExp('@page Section\\d+ .+?}', 'gm');
      const pageRules = cssText.match(asposeSizeRulesRegex);

      // Прочитаем список правил и установим их для секций
      const sectionSizes = {};
      const sectionNameRegex = new RegExp('Section\\d+', 'gm');
      const sizesRuleRegex = new RegExp('size:.+?(?=;)', 'gm');
      for (const pageRule of pageRules) {
        // Получить имя секции
        const sectionName = pageRule.match(sectionNameRegex)[0];

        // Получить размеры
        const sizeRule = pageRule.match(sizesRuleRegex)[0];
        const sizes = sizeRule.split(':');
        sectionSizes[ sectionName.toLowerCase() ] = sizes[1].split(' ');
      }

      return sectionSizes;
    }

    /**
     * Обработать комментарии.
     *
     * @method _prepareComments
     * @param {object} jContents jQuery-объект страницы.
     * @private
     * @static
     */
    static _prepareComments(jContents) {
      // Получить список anchor'ов комментариев
      const jCommentAnchors = jContents.find(asposeSelectors.commentAnchors);
      jCommentAnchors.addClass('msocomanchor');

      // Добавить классы к комментариям.
      const jComments = jContents.find(asposeSelectors.comments);
      jComments.addClass('msocomtxt');

      // Заменим инициалы в примечаниях на полное имя.
      jComments.each((index, domElement) => {
        const jCurrentComment = $(domElement);
        const infoStr = jCurrentComment.attr('style');
        if (infoStr) {
          try {
            const infos = infoStr.split(';');

            for (const info of infos) {
              const params = info.split(':');
              if (params[0] === '-aw-comment-author') {
                jCurrentComment.find(wordDocumentSelector.commentAnchors).html(params[1].replaceAll('\'', '') + '<br>');
              }
            }
          } catch (e) {
            // Если не удалось распарсить дополнительную информацию, то ничего не делаем,
            // в примечании останутся инициалы.
          }
        }
      });

      // Пройтись по списку anchor'ов и перенести комментарии в соответствующие контейнеры
      const documentAnchorSelector = `${wordDocumentSelector.wrapper.mainContent} ${asposeSelectors.commentAnchors}`;
      const jDocumentAnchors = jContents.find(documentAnchorSelector);
      jDocumentAnchors.each((index, domElement) => {
        // Получить селектор комментария из anchor'а
        const jCurrentAnchor = $(domElement);
        const commentSelector = jCurrentAnchor.attr('href');

        // Получить секцию комментариев, в которую необходимо переместить комментарий
        const jPage = jCurrentAnchor.closest(wordDocumentSelector.wrapper.page);
        const jCommentSection = jPage.find(wordDocumentSelector.wrapper.comments);

        // Получить комментарий и переместить в область комментариев
        const jComment = jComments.filter(commentSelector);
        jComment.appendTo(jCommentSection);

        // Установить положение по вертикали
        const jCurrentAnchorTop = jCurrentAnchor.offset().top;
        const jPageSection = jCurrentAnchor.closest('div[class*=Section]');
        const jPageSectionTop = jPageSection.offset().top;
        jComment.css('top', jCurrentAnchorTop - jPageSectionTop);
      });

      // Добавить класс к области выделения комментарием
      const jCommentSelections = jContents.find(asposeSelectors.commentArea);
      jCommentSelections.addClass('comment-area');

      // Добавить подсветку для комментариев
      this._commentHighlight(jContents, jCommentAnchors, jComments, jCommentSelections);
    }

    /**
     * Подсветка комментариев при наведении.
     *
     * @method _commentHighlight
     * @param {object} jContents jQuery-объект страницы.
     * @param {object} jCommentAnchors jQuery-объект гиперссылок.
     * @param {object} jComments jQuery-объект комментариев.
     * @param {object} jCommentSelections jQuery-объект выделений.
     * @private
     * @static
     */
    static _commentHighlight(jContents, jCommentAnchors, jComments, jCommentSelections) {
      // При наведении на anchor необходимо подсветить соответствующий комментарий и выделение
      jCommentAnchors.each((index, domElement) => {
        // Текущая гиперссылка
        const jCurrentAnchor = $(domElement);

        // Связанный комментарий
        const commentSelector = jCurrentAnchor.attr('href');
        const jCurrentComment = jComments.filter(commentSelector);

        // Связанный выделенный текст
        const commentSelectionSelector = `a[name=${commentSelector.replace('#_cmnt', '_cmntref')}]`;
        const jCurrentCommentSelection = jCommentSelections.filter(commentSelectionSelector);

        // Добавить подсветку для связанных элементов
        jCurrentAnchor.hover(() => {
          jCurrentComment.addClass('hovered');
          jCurrentCommentSelection.addClass('hovered');
        }, () => {
          jCurrentComment.removeClass('hovered');
          jCurrentCommentSelection.removeClass('hovered');
        });
        jCurrentComment.hover(() => {
          jCurrentCommentSelection.addClass('hovered');
        }, () => {
          jCurrentCommentSelection.removeClass('hovered');
        });
        jCurrentCommentSelection.hover(() => {
          jCurrentComment.addClass('hovered');
        }, () => {
          jCurrentComment.removeClass('hovered');
        });

        // При нажатии на anchor принудительно отображать комментарий поверх других
        jCurrentAnchor.click((event) => {
          event.preventDefault();
          this._showCommentOnTop(jComments, jCurrentComment);
        });
      });
    }

    /**
     * Отобразить комментарий поверх других.
     *
     * @method _showCommentOnTop
     * @param {object} jComments jQuery-объект со списком комментариев.
     * @param {object} jCurrentComment jQuery-объект текущего комментария.
     * @private
     * @static
     */
    static _showCommentOnTop(jComments, jCurrentComment) {
      jComments.removeClass('holdOnTop');
      jCurrentComment.addClass('holdOnTop');
    }
  }

  global.WordDocumentPostprocessor = WordDocumentPostprocessor;

})(window.Core.preview);